<template>
  <!-- eslint-disable -->
  <div>
    <p>歡迎使用 U Lifestyle 商戶中心。U Lifestyle 商戶中心提供一站式的線上互動推廣平台網站及/或
      應用程式予 U Lifestyle 用戶 （以下簡稱「會員」或 「顧客」）兌換或購買優惠，並由商戶提供、
      上載及管理優惠、商品或服務等（以下簡稱「本服務」）。</p>
    <br/>
    <h5>同意並接受條款</h5>
    <p>閣下/商戶 (以下簡稱: 「商戶」) 使用 U Lifestyle 商戶中心 (以下簡稱: 「本平台」) ，同時即代表商戶已細閱及同意接受下列條款及細則、《社群》一般條款及細則所約束。</p>
    <p>&nbsp;</p>
    <p>U Lifestyle (以下簡稱: 「我們」 或 「本公司」) 將保留一切權利，可不時更改或增減以下有關
      條款及細則之內容，並無需作出任何事前通知，修改後的條款及細則由發佈日開始生效。敬請
      留意本平台的公告及電郵等通知。商戶持續使用我們的商戶中心及本服務，即視為商戶同意接
      受有關及本條款及細則的最新版本、公告、使用說明及電郵通知。如果商戶不同意本服務條款
      的內容，商戶應立即停止使用本服務及通知我們。
    </p>
    <p>&nbsp;</p>

    <ol>
      <li>
        <strong><u>商戶的註冊義務</u></strong>
        <br/><br/>
        <ol>
          <li>為了能訪問及使用本商戶中心，商戶必須同意以下事項：</li>
            <ul class="disc">
              <li>必須註冊本平台，並按商戶註冊登記填寫所需的商戶資料 (以下簡稱「登記資料」），包括但不限於公司名稱、商業登記號碼等所提供的登記資訊必須正確無誤，並確保所提供的資料精確、最新及完整。申請人必須年滿18歲或以上。</li>
              <li>一旦註冊本平台，即代表閣下同意於成功申請成為優惠商戶後同步開通U Lifestyle《社群》會員帳戶及商戶帳號。</li>
              <li>若商戶提供任何錯誤、不實、過時、不完整或有誤導成分的資料，或者U Lifestyle有合理的理由懷疑登記資料為錯誤、不實、過時、不完整或有誤導成分的資料，U Lifestyle有權暫停或終止商戶的帳戶，並拒絕商戶現在及未來使用本服務之全部或部份。</li>
            </ul>
          <br/>
          <li>我們保留權利可全權酌情就任何理由拒絕申請、取消現有商戶帳戶。<br/><br/></li>
          <li>每個品牌只可建立一個商戶中心帳號，並同步開通U Lifestyle會員帳戶及《社群》商戶帳戶。
              商戶需委任一人為商戶代表及聯絡人，並填寫額外的通訊電郵 (排名第一名的電郵為商戶代表電郵)。
              如發現任何品牌以多於一個帳戶使用本平台，U Lifestyle 保留一切權利，包括有權即時取消該商戶及會員資格、
              取消並刪除其所有 U Lifestyle 帳戶、凍結該商戶之重複或違規U Lifestyle 帳戶、取消部份或所有優惠，而不會對商戶作另行通知，且毋須就此向閣下承擔法律責任或追索權。<br/><br/></li>
          <li>如發現商戶以空號、假帳戶或重複登記商戶中心帳號，或以任何方式擾亂或操控活動，U Lifestyle 有權取消有關人士的申請資格及刪除帳戶，而毋須事先通知、作出解釋或補償。<br/><br/></li>
          <li>優惠商戶帳號不能以任何方式與他人合計或轉讓給他人，而所有優惠商戶亦只能建立屬於其業務下的優惠。如發現有商戶違規，U Lifestyle 將保留一切權利，包括有權即時取消該商戶資格及同步刪除其U Lifestyle 會員帳戶及《社群》商戶帳戶。<br/><br/></li>
        </ol>
      </li>
      <li>
        <strong><u>商戶的保證、一般義務及責任</u></strong>
        <p>「商戶」是指於本平台上載及提供優惠、商品或服務的供應者。</p>
        <br/>
        <ol>
          <li>商戶及其參與商店(兌換地點)所提供的任何優惠、商品或服務之優惠出售及兌換負責，包括但不限於：<br/><br/></li>
            <ul class="alpha">
              <li>須根據已上傳的優惠券協議條款及/或描述提供並履行其服務/產品，包括但不限於優惠券所列明的描述、圖片等；</li>
              <li>在任何優惠券上施加任何條款及細則，包括質量、安全性、可用性或參與商店及/或兌換點提供的產品及/或服務的任何方面，違反任何適用的法律或法規；</li>
              <li>需提供相應及相稱的優惠、商品或服務數量，嚴禁超賣；</li>
              <li>任何參與商店及/或兌換點未能兌現任何優惠券；</li>
              <li>嚴禁於兌換時附加額外沒有列明的條款。</li>
            </ul><br/>

          <p>如發現商戶提供的商品或服務與優惠券上的資料不符合，U Lifestyle 有權立即終止有關交易及暫停商戶中心帳戶，並同步刪除其U Lifestyle會員帳戶及《社群》商戶帳戶而不作另行通知。商戶須對其上載到本平台發佈的內容及相關交易承擔全部/部分責任並承擔一切法律風險。</p>
          <li>商戶必須在優惠期內提供優惠券上的商品或服務。如因其他特別原因而不能兌換有關的商品、服務或需停止優惠，須即時通知U Lifestyle或自行到商戶中心暫停發佈有關優惠，否則商戶須要承擔一切法律責任及一切所產生的費用。<br/><br/></li>
          <li>如優惠券經確認後有任何資料更改，須即時通知U Lifestyle。<br/><br/></li>
          <li>商戶知悉並確認自行負責創建及營運本平台帳戶，以及營運U Lifestyle《社群》商戶帳戶。<br/><br/></li>
          <li>商戶須維持並促使所有關聯人士必須保持登入本平台 及U Lifestyle《社群》的用戶名稱(&ldquo;該用戶名稱&rdquo;)及密碼 (&ldquo;該密碼&rdquo;)之機密性，並負責其安全。
            商戶全權負責任何使用該用戶名稱及該密碼所進行的行動及交易。本公司不會承擔任何一切因使用本服務而引致因其疏忽或任何其他因素所引起的任何損失。<br/><br/></li>
          <li>商戶及其參與商店應全面遵守《商品說明條例》 (香港法例第362章) 及其他適用法律，
            以確保本平台上傳的資料/內容屬真實、合法、有效、最新、準確、不誤導及不侵犯第三方知識產權的權利等。<br/><br/></li>
          <li>
            商戶不得在本平台上上傳或提交任何非法、有害的、具恐嚇性的、具侮辱性的或有機會侵權的、含誹謗意味的、侵犯他人私隱的、鼓吹仇恨的不適當內容，
            例如但不限於銷售任何潛在危險的食品、煙草製品或任何法律禁止之相關內容、物品或服務。<br><br>
          </li>
          <li>有關商戶所提供的優惠、商品或服務之品質、用後反應、使用、顧客體驗、安全及服務條款，本公司概不負責，商戶需對其承擔一切這些責任。<br/><br/></li>
          <li>
            商戶應當把本平台之任何故障、錯誤及缺陷及時告知本公司。一旦商戶發現本平台的任何錯誤，商戶需向本公司提供其要求的輸出資訊清單以及其它資料，以讓本公司複製此等故障、錯誤及缺陷出現時的類似狀況。<br/><br/>
          </li>
          <li>商戶發佈內容守則︰
            U Lifestyle 擁有絕對酌情權可於不一定向閣下發出通知的情況下，因違反以下任何條款或其他原因而終止閣下進入、瀏覽、使用本平台，或終止閣下U Lifestyle 商戶中心、U Lifestyle會員帳戶及《社群》商戶帳戶，同時終止其他相關優惠，且毋須就此向閣下承擔法律責任或追索權。
            <ul class="disc">
              <li>內容禁止含有粗言穢語、人身攻擊或色情的文字和圖片。內容請勿作人身攻擊，請尊重每一位留言者。</li>
              <li>嚴禁冒充他人身分或盜用帳戶。</li>
              <li>嚴禁冒充他人身分或盜用帳戶。</li>
              <li>嚴禁發佈含有病毒或其他有害軟件的內容。</li>
              <li>嚴禁提供盜版軟件或侵權內容以供網友下載。</li>
              <li>嚴禁刊登他人或自己的私人資料，包括相片、電話號碼和地址等。</li>
              <li>嚴禁未經授權而擅自轉載其他雜誌及網站的內容。</li>
              <li>嚴禁在未經同意下發佈任何直接或間接的廣告內容。</li>
              <li>商戶發怖所有內容，並與本公司立場無關。</li>
              <li>在完成訂單前(收貨/兌換優惠前)，商戶不可向顧客提供與我們業務性質相近機構再行銷優惠及宣傳內容。</li>
              <li>嚴禁上傳、刊登或散播任何觸犯或違反香港現時生效的法律、法例或規例的內容或資訊，該等內容或資訊包括但不限於︰</li>
              <ul class="roman">
                <li>根據《吸煙(公眾衞生)條例》(第371章)第四部，任何人不得展示或安排展示，或為展示用途而刊登或分發任何形式的煙草廣告。同時亦禁止在印刷刊物、公眾地方、電影及互聯網等展示煙草廣告，請參考香港法例《吸煙(公眾衞生)條例》(第371章)以了解《條例》詳情。</li>
                <li>根據《不良廣告（醫藥）條例》（第 231 章），禁止發佈危害公眾健康廣告或內容，請參考香港法例（第231章）以了解《條例》詳情。</li>
                <li>根據香港法例第109章《2018 年應課稅品(修訂)條例》的規定，不得在業務過程中，向未成年人售賣或供應令人醺醉的酒類，如透過遙距方式(例如互聯網或電話)售賣或供應令人醺醉的酒類，則必須在售賣該酒類前，在網上商店以合理可閱的方式展示訂明通知，或讀出訂明通知的內容。請參考香港法例第109章《2018 年應課稅品(修訂)條例》以了解《條例》詳情。</li>
                <li>根據《危險藥物條例》，非法販運（包括進口及出口）及製造受管制物質的最高刑罰為終身監禁及罰款500萬元。違反《危險藥物條例》管有及服用受管制物質的最高刑罰為監禁七年及罰款100萬元。受管制物質包括含有大麻，例如大麻二酚 (CBD)、大麻萜酚 (CBG)、大麻酚 (CBN)、四氫大麻酚 (THC) 等等及／或其衍生物，鴉片類及其他違禁藥物的產品。請參考香港法例第134章《危險藥物條例》以了解詳情。</li>
              </ul>
              <li>如任何人士在本平台作出違規/違法或懷疑違規/違法行為（如誹謗或侵權），本平台將會在要求下交出違規者的資料作日後追究用途。</li>
              <li>本公司有權在不作通知的情況下刪除站內的任何內容。</li><br/>
            </ul>
          </li>
          <li>商戶同意本公司有權在任何頻道上發佈之前，將本平台提供的任何優惠券及材料的內容預先篩選並需要於數個工作天內審核，並對本平台及/或渠道上違反條款及細則的任何條款或協議或適用法律或規例之任何資料進行預先篩選、拒絕或刪除。<br/><br/>
          </li>
        </ol>
      </li>
      <!-- <p>&nbsp;</p> -->
      <li><strong><u>上載商品</u></strong><strong><u><br/><br/></u></strong>
        <ol>
          <li>
            於本平台上載優惠時，必須於「優惠描述及適用網店或實體分店地址」及「條款及細則」詳細列明一切的使用條件、享有的優惠、兌換方法等，並於「優惠使用期限」內實施。
            商戶須根據已上傳的優惠券協議條款及/或描述提供並履行其服務/產品及負責，詳情可以參閱「商戶的保證、一般義務及責任」部分。<br/><br/>
          </li>
          <li>
            商戶同意本公司有權在任何頻道上發佈之前，將本平台提供的任何優惠券及材料的內容預先並需要於數個工作篩選及審核，
            並對本平台及/或渠道上違反條款與細則的任何條款或協議或適用法律或規例之任何資料進行預先篩選、拒絕或刪除。
          <br/><br/></li>
          <!-- <li>商家同意本公司有權要求用戶及會員使用相應積分「U Fun」來換取商家提供予U Lifestyle的折扣或禮品。「U Fun」可從會員專區的「任務清單」中賺取。每張優惠券需定立一個與它有相應價值的「U Fun」以供會員兌換。更多關於《UU積FUN賞》之條款及細則：
            <a target="_blank" href="https://www.ulifestyle.com.hk/res/static/v3/tandc.html">按此</a><br/>
            <strong><u><br/><br/></u></strong>
          </li> -->
        </ol>
      </li>
      <li><strong><u>優惠券上傳/訂單狀態及確立</u></strong><strong><u><br/><br/></u></strong>
        <ol>
          <li>積分/付費優惠券上傳狀態</li>
            <ul class="disc">
              <li>「審批中」：優惠券正在審批中。</li>
              <li>「已發佈」：優惠券已經正式發佈，可於本平台「U Jetso」優惠專區頁面查看優惠券。</li>
              <li>「已排程」：優惠券已完成審批，並將會按照您自訂的發佈時間於本平台發佈。
                  若您沒有自訂發佈時間，優惠券將會於通個審批後排期發佈。
              </li>
              <li>「已暫停」： 您的優惠券已被暫時下架，請儘快電郵與我們聯絡。</li>
              <li>「已拒絕」：您的優惠券申請被拒絕。常見原因但不限於：</li>
                <ul class="circle">
                  <li>商品不適合</li>
                  <li>優惠折扣太低</li>
                  <li>優惠期限過短/長</li>
                  <li>商品資料錯誤</li>
                  <li>上載圖片清晰度低</li>
                  <li>上載圖片不符</li>
                  <li>自訂發佈時間錯誤</li>
                  <li>條款及細則不清晰</li>
                  <li>獨特優惠碼檔案格式錯誤</li>
                  <li>未能聯絡貴公司負責人</li>
                </ul>
              <li>「已過期」：您設定的優惠券推廣期已經完結，歡迎再次建立新的優惠券。<br/><br/></li>
            </ul>
          <li>
            訂購商品、服務或換領優惠確立
          </li>
          <ol>
            <li>一般確立情況 (適用於積分及付費優惠券)</li>
              <ul class="disc">
                <li>電子優惠券一經滑動或經掃描二維碼 (QR Code)，商戶可視為「已兌換」。若換領優惠前，
                    商戶有權因顧客任何原因已兌換或遺失此券，恕不獲補發給顧客。在這個情況下，商戶有對優惠券使用的最終決定權。
                </li>
                <li>請讓顧客在網絡穩定的情況下使用此券，因網絡不穩等問題導致未能換領優惠，
                  U Lifestyle 概不負責。<br/><br/>
                </li>
              </ul>
            <li>積分優惠券確立</li>
              <ul class="disc">
                <li>當顧客作出換領優惠券時，即表示商戶需按優惠的條款及細則提供商品或服務，商戶不得取消有關優惠。<br/><br/></li>
              </ul>
            <li>付費優惠券確立</li>
              <ul class="disc">
                <li>商戶會收到訂單的電子郵件、或顯示於本平台「銷售訂單」，狀態顯示為「已完成」即代表訂單已確立及顧客已付款。當顧客作出訂購時，即表示商戶需按優惠的條款及細則提供商品或服務優惠，商戶不得取消有關訂單。訂單不遲於2個工作天內確認。
                </li>
                <li>付費優惠券確立於銷售訂單顯示的狀態</li>
                <ul class="circle">
                  <li>「已完成」：訂單已確立及顧客已付款。</li>
                  <li>「退款中」：訂單正在處理退款中。商戶已聯繫我們申請退款，符合「交易取消、退款及程序」所列明的原因，並得到書面確認處理中。</li>
                  <li>「已退款」：訂單已成功退款，費用已退回顧客選擇的支付方式當中。詳細請參閱「交易取消、退款及程序」。</li>
                </ul>
                <li>本網站所有價格均以港幣計算。請確保上載顯示的價格為準確及最新，本公司不會因為價格錯誤所招致的損失而負責。</li>
                <li>每張付費優惠券／每件產品的最終售價（優惠價）須不少於HK$10。</li>
                <li>本網站僅接受 Visa信用卡、Master Card信用卡付款。</li>
                <li>由商戶直送商品，須於訂單確立後10天內或於優惠條款及細則或描述所指定的出貨時間內發貨。用戶須確保填寫的訂單資料正確無誤，並由用戶承擔因資料填寫錯誤或郵遞送貨之寄失或損毀之風險，U Lifestyle有權不作任何的補償或更換。商戶有責任向用戶更新送貨狀態，包括發貨日期、運單編號等。<br/><br/>
                </li>
              </ul>
          </ol>
        </ol>
      </li>
      <li><strong><u>商品/服務兌換</u></strong><strong><u><br/><br/></u></strong>
        <ul class="disc">
          <li>商戶需要提供電子優惠碼或使用二維碼 (QR Code)讓顧客兌換。</li>
          <li>
            <b>獨特優惠碼</b>是由一組獨特的字母及數字組成，按商戶所提供的獨特優惠碼數量來控制優惠券 供應數量，
            每一位換取優惠的會員都會收到不同的優惠碼，以避免重覆使用優惠，適用於<u>有限額</u>之優惠。
            <b>通用優惠碼</b>是所有換取優惠的會員都會收到一組相同的優惠碼，<u>有限額及沒有限額</u>的優惠均適用。
          </li>
          <li>
            如果優惠適用於<b>網上商店</b>，用戶需<b>自行滑動以取得電子優惠碼</b>，
            按「完成並離開」後，優惠券狀態將由「可使用」變為「已兌換」。
          </li>
          <li>
            如果優惠適用於<b>實體店</b>，商戶可要求客人於結帳前出示相應電子優惠券頁面，
            <b>由職員滑動以確認使用優惠碼</b>，完成兌換程序，優惠券狀態由「可使用」變為「已兌換」。
          </li>
          <li>
            如選用二維碼 (QR Code) 優惠券，商戶必須使用 U Lifestyle 商戶中心所提供的商戶專屬二維碼掃描器兌換優惠。
            若使用其他掃描器，在兌換過程中如產生任何損失或爭議，U Lifestyle並不負責，並須由商戶承擔損失。
          </li>
          <li>
            請確保在「優惠使用期限」前或內於你的網店、實體店或兌換點上上架電子優惠碼、商品、套票等。
          </li>
          <li>
            商家承諾並促使所有其參與商店(兌換地點)(包括商家授權使用系統的任何工作人士（”授權使用者”)、其僱員、代理人和承包商(統稱“關聯人士”)須遵守協議上的條款。商家須就參與商店或關聯人士違反協議的任何條款及細則而負全責。商戶及其參與商店(兌換地點)有責任儘量讓當值員工知悉優惠內容、使用方法及保持使用一致性。
          </li>
          <li>
            除商戶另有規定外，概不接受顧客退貨或更換貨物。商戶可自行規定商品的退換貨政策，但不能向我們申請退款。請僅記在上載優惠時訂明退貨或更換政策。<br/><br/>
          </li>
        </ul>
      </li>

      <li><strong><u>交易取消、退款及程序</u></strong><strong><u><br/><br/></u></strong>
        <ol>
          <li>以下是部分但不限於導致交易取消之常見原因：</li>
            <ul class="disc">
              <li>未付款或未能於系統指定期限內付款；</li>
              <li>未能通過銀行驗證。</li>
              <p>交易取消即沒完成付款的訂單，不會產生任何的收益或「平台費」，商戶無需向會員提供相關優惠。</p>
            </ul>
          <li>以下是部分但不限於未能向本公司提出申請退款之常見原因：</li>
            <ul class="disc">
              <li>會員向商戶退還貨品；</li>
              <li>會員向商戶不合理地取消服務；</li>
              <li>會員沒有使用優惠券購物、兌換商品或出席服務；</li>
              <li>會員已滑動已兌換優惠券；</li>
              <li>會員兌換日期已過或未能符合兌換的條件；</li>
              <li>商戶與會員私下更改優惠條款及細則；</li>
              <li>商戶因人為或電腦錯誤定價但已售出優惠；</li>
              <li>產品並無足夠的存貨；</li>
              <li>商戶違反商戶中心使用條款與細則。<br/><br/></li>
            </ul>

          <li>
            會員若在未兌換及未滑動付款優惠券時向商戶要求中止交易並要求申請退款，須於訂單確認後的5個工作天內聯絡本公司，我們會因應個案原因、合理情況酌情處理，必須符合會員使用原則要求，「平台費」會由商戶承擔，本公司亦保留最終決定權。<br/><br/>
          </li>

          <li>
            會員不可以單方面中止已承諾或已售出的優惠券而要求申請退款，
            除因應突發而未能預計的情況未能提供服務或商品(如政府限制處所營業)，
            才可向我們申請退款，而「平台費」會由商戶承擔，本公司亦保留最終決定權。<br/><br/>
          </li>

          <li>
            退款申請必須以整個訂單申請。申請退款有機會延長商戶收款的時間，請留意
            電郵通知。每項退款將不會退回已收取的「平台費」，需要由商戶承擔。<br/><br/>
          </li>

          <li>
            退款程序
            <p>
              當我們處理及接納退款申請，我們會以電郵通知商戶有關交易取消，所有退款將會退
              回至顧客訂單所選用的支付方法。若商戶未收取該款項，所退款金額會直接由商戶可
              申請的收款戶口自動扣除，而如該款項早已完成收款程序，商戶需於 10 個工作天內向
              我們退回相關款項以便進行客戶退款程序。
            </p>
          </li>
        </ol>
      </li>

      <li><strong><u>收款方式與流程</u></strong><strong><u><br/><br/></u></strong>
        <ol>
          <li>符合下列條件，商戶便可於「收款紀錄」申請收取所獲得實際銷售收益：</li>
            <ul class="disc">
              <li>當顧客完成整個付款程序所達成訂單；及</li>
              <li>申請收款時沒有任何訂單進行退款申請；及</li>
              <li>實際銷售收益已達 港幣$1,000；及</li>
              <li>於「帳戶設定」中正確填寫銀行資料及戶口號碼。<br/><br/></li>
            </ul>
          <li><b>收款申請</b>截數日期為 <b>每月 20 日</b>，<b>收款申請</b>處理大約為 3 星期，商戶約於 3 星
              期內收到有關實際銷售收益<b>款項</b>。收款戶口必須選擇 <b>中國銀行(香港)有限公司
              或 香港滙豐銀行進行款項過數 或 U Lifestyle 同意以郵寄支票付款 (商戶須承擔郵寄寄失的風險)。在每月截數日前只可申請一次，並可以於截數日後再次申請。</b><br/><br/>
          </li>
          <li>
            請確保「帳戶設定」中正確填寫銀行資料，如因資料錯誤而導致無法轉帳或轉帳到錯誤的戶口，本公司並不負責，並由商戶承擔損失。<br/><br/>
          </li>
          <li>收款流程：</li>
            <ul class="none">
              <li>步驟1：符合收款申請條件，並向我們申請 <b>(每月20日截數)</b></li>
              <li>步驟2：本公司核對帳目及處理收款申請 (約為3星期)</li>
              <li>步驟 3：如帳目正確，商戶約於 3 星期內收到銀行入帳，並於本平台收款紀錄顯示，商戶可自行下載收款紀錄。*</li>
              <li>如帳目出現問題，會以電郵書面通知，<b>收款申請時間有機會延長，一切以電郵通知及確認內容作準。</b></li>
              <li>*僅記請檢查每月收款紀錄及入數金額是否正確。如有錯誤，商戶必須於收款紀錄之匯款日期3個月內向本公司查詢，逾期將不獲受理。<br/><br/></li>
            </ul>
        </ol>
      </li>
      <li><strong><u>消費爭議處理</u></strong><strong><u><br/><br/></u></strong>
        <ol>
          <li>除非另有註明，否則我們並非商品的賣家或供應商。我們僅提供推廣銷售平台、負責管理網站、安排訂單處理過程，並非優惠、商品或服務提供者。<br/><br/></li>
          <li>
            商戶需要處理各優惠及內容之相關問題，包括但不限於會員對優惠券使用查詢、
            商品出現品質問題，因使用條款的消費爭議等。一切契約及賠償責任需由商戶自
            行負責處理。若因優惠更換細則、超賣或消費紛爭，商戶須給予適當之處理，除
            非與商戶另有書面約定，否則本公司對此概不負責。<br/><br/>
          </li>
          <li>
           若然<b>消費爭議源於</b>本平台系統性問題，包括但不限於重覆訂單、付款爭議等。
          請於完成訂單後 5 個工作天內與我們聯繫及提供證據並以書面通知，而「平台費」
          會由本公司承擔，本公司對期限後之爭議概不負責。<br/><br/>
          </li>
        </ol>
      </li>
      <li><strong><u>修改本服務和收費</u></strong><strong><u><br/><br/></u></strong>
        <ol>
          <p>
            一般而言，上載積分優惠券為免費，付費優惠券需支付本公司「平台費」為每個成功
            訂單售價的 5% (例如: 出售五張餐飲禮券，每張禮券價值為港幣$100，需要支付「平台
            費」為<u>港幣$25</u> - 港幣$100 x 5 張 x 5% )及扣除一切所有應繳的費用(如: 退款所產生的費
            用)。「平台費」之更新會於更新前最少 10 個工作天內由本公司電郵/公告通知現有商
            戶。本公司保留在不通知的情況下隨時或不時修改任何部分的本服務及平台費用之權
            利。
          </p>
        </ol>
      </li>
      <li><strong><u>取消和終止</u></strong><strong><u><br/><br/></u></strong>
        <ol>
          <li>閣下/商戶可以隨時聯繫我們，然後按照我們指示的特定說明，隨時取消帳戶並終止服務。請注意，取消U Lifestyle商戶中心帳戶將同步取消U Lifestyle會員帳戶及 《社群》商戶帳戶。<br/><br/></li>
          <li>任何一方出於任何原因終止服務後：</li>
            <ul class="disc">
              <li>將停止為閣下/商戶提供服務，並且商戶將不再能夠訪問U Lifestyle商戶中心帳戶、U Lifestyle會員帳戶及《社群》商戶帳戶；及</li>
              <li>除非服務條款另有規定，否則閣下/商戶無權按比例或以其他方式退還任何費用；及</li>
              <li>在此類終止生效之日前，商戶需為因使用服務而欠本公司的任何未償餘額全額支付；及</li>
              <li>該帳戶將變為離線狀態。<br/><br/></li>
            </ul>
        </ol>
      </li>
      <li><strong><u>內容許可</u></strong><strong><u><br/><br/></u></strong>
        <ol>
          <li>
            商戶向本公司授予非獨家的、全球性的、免版稅的權利和許可，以使用、發佈、託管、展示、改編、修改、推廣、複製、下載、分發許可權、轉發、散發、複製、轉讓及/或提供給本公司編輯資料及內容，及/或商戶和參與商店或關聯人士把所需的資料及內容上傳到本平台，讓本公司得以履行本協議所規定的義務，包括但不限於在本公司認為適當的任何媒體中進行營銷、促銷、再分發及使用此類信息進行分析 。U Lifestyle有權毋須預先知會閣下。閣下同意倘若閣下的商戶內容一經選用，該等內容的版權將會由U Lifestyle所全權擁有。如果閣下不同意上述，閣下應立即停止於U Lifestyle張貼或發佈任何商戶內容，以及停止使用U Lifestyle服務。<br/><br/>
          </li>
          <li>
            商戶同意本公司有權要求用戶及會員使用相應積分「U Fun」來換取商戶提供予U Lifestyle的折扣或禮品。「U Fun」可從《U Jetso》優惠專區的「賺分任務」或個人帳戶的「UU積FUN賞」中賺取。每張優惠券需定立一個與它有相應價值的「U Fun」以供會員兌換。而「U Fun」並無金錢價值，不能以任何方式兌換現金，亦不會兌換任何金錢價值給予商戶。更多關於 U Fun之條款及細則：<a href="https://www.ulifestyle.com.hk/res/static/v3/tandc.html" target="_blank"><u>按此</u></a><br/><br/>
          </li>
        </ol>
      </li>
      <li><strong><u>私隱及知識產權政策</u></strong><strong><u><br/><br/></u></strong>
        <ol>
          <li>
            為了使用本服務，閣下/商戶亦須同意「私隱政策」之條款，以保障閣下/商戶及其他用戶之個人資料，請按此連結至「私隱政策」一頁 : <a href="https://www.ulifestyle.com.hk/aboutus" target="_blank"><u>(https://www.ulifestyle.com.hk/aboutus)</u></a>，以閱讀有關條款。<br/><br/>
          </li>
          <li>
            商戶同意允許我們因需要與合作夥伴或第三方服務提供者(包括但不限於支付平台)提供個人/登記資料。<br/><br/>
          </li>
          <li>
            商戶、本公司及其各自的關聯人士應當對另一方保密性質的資訊及資料或一般需按照保密資訊對待的資訊及資料進行保密，不得利用此保密資訊，包括不限於服務訂單及本平台相關的資訊、開發資訊、技術資訊、產品資訊、銷售資訊、市場營銷資訊、宣傳資訊、營運資訊、績效資訊、成本資訊、政策資訊、財務資訊、商業資訊、流程資訊以及其他專有資訊、客戶及其他方的客戶資料（簡稱“保密資訊”），且應促成本身的管理人員、僱員、代理人及承包商保密資訊限用於履行其在協議下之義務。<br/><br/>
          </li>
          <li>
            商戶向本公司授予非獨家的、全球性的、免版稅的權利及許可，以使用、發佈、託管、展示、改編、修改、推廣、複製、下載、分發許可權、轉發、散發、複製、轉讓及/或提供給本公司編輯資料及內容，及/或商戶及參與餐廳/商店或關聯人士把所需的資料及內容上傳到本平台，讓本公司得以履行本協議所規定的義務，包括但不限於在本公司認為適當的任何媒體中進行營銷、促銷、再分發和使用此類信息進行分析 。<br/><br/>
          </li>
          <li>
            商戶不可向第三方機構提供或轉售顧客的個人資料(除法定要求外)以保障 U Lifestyle 會員的私隱，如因應服務需要使用顧客的個人資料，必須獲得U Lifestyle 同意。<br/><br/>
          </li>
        </ol>
      </li>
      <li><strong><u>免責聲明</u></strong><strong><u><br/><br/></u></strong>
        <ol>
          <li>
            在任何情況下，因閣下/商戶登記註冊成為U Lifestyle 商戶或使用閣下/商戶的 U Lifestyle會員帳戶及《社群》商戶帳戶而引起的任何直接、間接、附帶、相應或懲罰性損害，或任何利潤或收入損失之損害賠償，U Lifestyle 將不會負上任何法律或其他責任，而閣下/商戶亦不應要求我們就此承擔責任。<br/><br>
          </li>
          <li>
            本公司不作任何保證能否不間斷地、連續地或確保可以連接U Lifestyle網站及U Lifestyle App。U Lifestyle 保留因不同的原因，包括但不限於緊急系統維修或提升而將本網站的任何部分或全部離線的權利。<br/><br/>
          </li>
          <li>
            U Lifestyle 不負責，亦不承擔任何損失或損害是由於不可抗力情況的發生，如發生火災、水災、暴雨、颱風、閃電、地震、暴動、騷動、戰爭或其他自然災禍等不可控制的事故、或有關法例或監管守則的制定或更改及政府或有關機構的限制、或在 U Lifestyle 不可合理控制的情況下 ( 包括但不限於資訊內容的傳送延誤或錯誤 ) ，引致 U Lifestyle 不能履行協議內的責任或提供服務。<br/><br>
          </li>
        </ol>
      </li>
      <li><strong><u>其他</u></strong><strong><u><br/><br/></u></strong>
        <ol>
          <li>
            U Lifestyle保留權利隨時自行更改、撤回或終止所有計劃、獎賞、禮遇、條款及細則，任何改動將於 U Lifestyle 各頻道之會員專區內公開發佈，而不會對會員作另行通知。<br/><br>
          </li>
          <li>
            優惠相關的日期及時間均以香港時間及本公司的伺服器時間為準。<br/><br/>
          </li>
          <li>
            官網之免責聲明、使用條款、私隱政策 、U Fun及《社群》之條款及細則適用於此條款當中。<br/><br>
          </li>
          <li>
            U Lifestyle《社群》商戶帳戶無法參與《社群》升級計劃及申請「社群創作有價企劃」。<br/><br>
          </li>
          <li>
            一切有關商戶中心平台使用條款及細則會以中文版本較為準確。所有條款及細
            則受香港現行法律管轄。如有任何爭議，U Lifestyle保留最終決定權。<br/><br>
          </li>
        </ol>
      </li>
    </ol>
    <!-- <p>&nbsp;</p> -->
    <!-- <ol start="3">

    </ol>
    <ol start="4" id="privacy">
      <li><strong><u>私隱政策</u></strong><strong><u><br/><br/></u></strong>
        <ul>
          <li>
            為了使用本服務，閣下亦須同意「私隱政策」之條款，以保障閣下及其他用戶之個人資料，請按此連結至「<a href="https://www.ulifestyle.com.hk/aboutus" target="_blank">私隱政策</a>」一頁以閱讀有關條款。
            <br/><br/>
          </li>
          <li>
            商家、本公司和及其各自的關聯人士應當對另一方保密性質的資訊和資料或一般需按照保密資訊對待的資訊和資料進行保密，不得利用此保密資訊，包括不限於服務訂單及系統相關的資訊、開發資訊、技術資訊、產品資訊、銷售資訊、市場營銷資訊、宣傳資訊、營運資訊、績效資訊、成本資訊、政策資訊、財務資訊、商業資訊、流程資訊以及其他專有資訊、客戶和其他方的客戶資料（簡稱&ldquo;保密資訊&rdquo;），且應促成本身的管理人員、僱員、代理人和承包商保密資訊限用於履行其在協議下之義務。
            <br/><br/>
          </li>
          <li>
            商家向本公司授予非獨家的、全球性的、免版稅的權利和許可，以使用、發佈、託管、展示、改編、修改、推廣、複製、下載、分發許可權、轉發、散發、複製、轉讓和/或提供給本公司編輯資料和內容，和/或商家和參與餐廳/商店或關聯人士把所需的資料和內容上傳到系統，讓本公司得以履行本協議所規定的義務，包括但不限於在本公司認為適當的任何媒體中進行營銷、促銷和再分發和使用此類信息進行分析 。
          </li>
        </ul>
      </li>
    </ol>
    <p>&nbsp;</p> -->
    <!-- <ol start="5">
      <li><strong><u>免責聲明</u></strong><br/><br/>
        <ul>
          <li>在任何情況下，因閣下登記註冊成為U Lifestyle 商戶或使用閣下的 U Lifestyle帳戶而引起的任何直接、間接、附帶、相應或懲罰性損害，或任何利潤或收入損失之損害賠償，U Lifestyle
            將不會負上任何法律或其他責任，而閣下亦不應要求我們就此承擔責任。<br/><br/></li>
        </ul>
      </li>
      <li><strong><u>其他</u></strong><br/><br/>
        <ul>
          <li>所有禮遇均不得退回或更換其他禮遇，而 U Fun 亦不會退回。<br/><br/></li>
          <li>U Lifestyle保留權利隨時自行更改、撤回或終止所有計劃、獎賞、禮遇、條款及細則，而不會對會員作另行通知。<br/><br/></li>
          <li>香港經濟日報員工及家屬不得參與是次活動，以示公允。<br/><br/></li>
          <li>優惠相關的日期及時間均以香港時間及本公司的伺服器時間為準。<br/><br/></li>
          <li>如有任何爭議，U Lifestyle保留最終決定權。<br/><br/></li>
        </ul>
      </li>
    </ol> -->
    <p>
      <strong>
        *如有查詢，請電郵至 <a href="mailto:eCoupon@ulifestyle.com.hk">eCoupon@ulifestyle.com.hk</a>。
      </strong>
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
ol { counter-reset: item }
ol > li{ display: block }
ol > li:before { content: counters(item, ".") ". "; counter-increment: item }
li ol > li:before {
  content: counters(item, ".") " ";
}
ul.circle {list-style-type: circle;}
ul.disc {list-style-type: disc;}
ul.alpha {list-style-type: lower-alpha;}
ul.roman {list-style-type: lower-roman;}
ul.none {list-style-type: none;}

</style>
